import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ToolbarComponent } from './common/components/toolbar/toolbar.component';
import { SidenavComponent } from './common/components/sidenav/sidenav.component';

import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MaterialModule } from './material.module';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from "@angular/material/form-field";
import { CdkDragDrop, CdkDrag, CdkDropList, moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';

import { LoginComponent } from './pages/common/login/login.component';
import { UserInfoComponent } from './common/components/user-info/user-info.component';
// import { UserEditComponent } from './pages/user/user-edit/user-edit.component';
import { ConfirmDialogComponent } from './common/components/confirm-dialog/confirm-dialog.component';
import { MasterFloatingMenuComponent } from './common/components/master-floating-menu/master-floating-menu.component';
// import { UserListItemComponent } from './pages/user/components/user-list-item/user-list-item.component';
// import { UserComponent } from './pages/user/user.component';
import { SnackBarComponent } from './common/components/snackbar/snackbar.component';
// import { UserEditDialogComponent } from './pages/user/dialogs/user-edit-dialog/user-edit-dialog.component';
import { StylePaginatorDirective } from './common/components/paginator/style-paginator.directive';
import { SimplePaginatorComponent } from './common/components/paginator/simple-paginator/simple-paginator.component';
import { TokenInterceptorService } from './auth/token-interceptor.service';
import { SorterComponent } from './common/components/sorter/sorter.component';
import { LoaderComponent } from './common/components/loader/loader.component';
import { SearchFilterComponent } from './common/components/search-filter/search-filter.component';
import { FilterItemComponent } from './common/components/search-filter/filter-item/filter-item.component';

// import { UserSummaryComponent } from './pages/user/components/user-summary/user-summary.component';
import { ExtraPagesMenuComponent } from './common/components/extra-pages-menu/extra-pages-menu.component';
import { SearchFilterSaveDialogComponent } from './common/components/search-filter/dialogs/search-filter-save-dialog/search-filter-save-dialog.component';
import { SearchFilterLoadDialogComponent } from './common/components/search-filter/dialogs/search-filter-load-dialog/search-filter-load-dialog.component';
import { FilterDialogComponent } from './common/components/search-filter/dialogs/filter-dialog/filter-dialog.component';
// import { ChangePasswordDialogComponent } from './pages/user/dialogs/change-password-dialog/change-password-dialog.component';
import { OrderStatusPipe } from './common/pipes/order-status.pipe';
import { ReversePipe } from './common/pipes/reverse.pipe';
import { DaysCustomPipe } from './common/pipes/days.pipe';
import { MonthsCustomPipe } from './common/pipes/month.pipe';
import { OODatePipe } from './common/pipes/date.pipe';
import { QuillModule } from 'ngx-quill';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { CommonModule, DatePipe } from '@angular/common';
import { EmployeeMenuComponent } from './pages/common/employees/employee-menu/employee-menu.component';
import { EmployeeComponent } from './pages/common/employees/employee/employee.component';
import { EmployeeExtComponent } from './pages/common/employees/employee-ext/employee-ext.component';
import { EmployeeExtEditComponent } from './pages/common/employees/employee-ext/employee-ext-edit/employee-ext-edit.component';
import { SystemComponent } from './pages/common/system/system/system.component';
import { SystemMenuComponent } from './pages/common/system/system-menu/system-menu.component';
import { ProductComponent } from './pages/common/products/product/product.component';
import { ProductMenuComponent } from './pages/common/products/product-menu/product-menu.component';
import { PromotionMenuComponent } from './pages/common/promotions/promotion-menu/promotion-menu.component';
import { PromotionComponent } from './pages/common/promotions/promotion/promotion.component';
import { ReportComponent } from './pages/common/reports/report/report.component';
import { UserMenuComponent } from './pages/common/users/user-menu/user-menu.component';
import { UserComponent } from './pages/common/users/user/user.component';
import { UtilMenuComponent } from './pages/common/utils/util-menu/util-menu.component';
import { ReportMenuComponent } from './pages/common/reports/report-menu/report-menu.component';
import { DepartmentComponent } from './pages/common/system/department/department.component';
import { DepartmentEditComponent } from './pages/common/system/department/department-edit/department-edit.component';
import { DepartmentSummaryComponent } from './pages/common/system/department/components/department-summary/department-summary.component';
import { EmployeeCategoryComponent } from './pages/common/employees/employee-category/employee-category/employee-category.component';
import { EmployeeCategorySummaryComponent } from './pages/common/employees/employee-category/employee-category/components/employee-category-summary/employee-category-summary.component';
import { EmployeeCategoryEditComponent } from './pages/common/employees/employee-category/employee-category/employee-category-edit/employee-category-edit.component';
import { AreaComponent } from './pages/common/system/area/area.component';
import { AreaSummaryComponent } from './pages/common/system/area/components/area-summary/area-summary.component';
import { AreaEditComponent } from './pages/common/system/area/area-edit/area-edit/area-edit.component';
import { ShopinfoComponent } from './pages/common/system/shopinfo/shopinfo.component';
import { ShopSummaryComponent } from './pages/common/system/shopinfo/components/shop-summary/shop-summary.component';
import { ShopEditComponent } from './pages/common/system/shopinfo/shop-edit/shop-edit.component';
import { SystemSettingsComponent } from './pages/common/system/system-settings/system-settings.component';
import { UomComponent } from './pages/common/products/uom/uom.component';
import { UomEditComponent } from './pages/common/products/uom/uom-edit/uom-edit.component';
import { UomSummaryComponent } from './pages/common/products/uom/components/uom-summary/uom-summary.component';
import { ItemCategoryComponent } from './pages/common/products/item-category/item-category.component';
import { ItemCategoryEditComponent } from './pages/common/products/item-category/item-category-edit/item-category-edit.component';
import { ItemCategorySummaryComponent } from './pages/common/products/item-category/components/item-category-summary/item-category-summary.component';
import { StockCategoryComponent } from './pages/common/products/stock-category/stock-category/stock-category.component';
import { StocksSummaryComponent } from './pages/common/products/stocks/stocks/components/stocks-summary/stocks-summary.component';
import { StockCategoryEditComponent } from './pages/common/products/stock-category/stock-category/stock-category-edit/stock-category-edit.component';
import { StocksComponent } from './pages/common/products/stocks/stocks/stocks.component';
import { StocksEditComponent } from './pages/common/products/stocks/stocks/stocks-edit/stocks-edit.component';
import { SaleItemComponent } from './pages/common/products/sale-item/sale-item.component';
import { SaleItemEditComponent } from './pages/common/products/sale-item/sale-item-edit/sale-item-edit.component';
import { SaleItemSummaryComponent } from './pages/common/products/sale-item/components/sale-item-summary/sale-item-summary.component';
import { SaleItemBulkUpdateComponent } from './pages/common/products/sale-item-bulk-update/sale-item-bulk-update.component';
import { SaleItemBulkUpdateExportDialogComponent } from './pages/common/products/sale-item-bulk-update/dialogs/sale-item-bulk-update-export-dialog/sale-item-bulk-update-export-dialog.component';
import { SaleItemBulkUpdateScheduleDialogComponent } from './pages/common/products/sale-item-bulk-update/dialogs/sale-item-bulk-update-schedule-dialog/sale-item-bulk-update-schedule-dialog.component';
import { SaleItemBulkUpdateImportDialogComponent } from './pages/common/products/sale-item-bulk-update/dialogs/sale-item-bulk-update-import-dialog/sale-item-bulk-update-import-dialog.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { WeeklyResultByStoreReportComponent } from './pages/common/reports/weekly-result-by-store-report/weekly-result-by-store-report.component';
import { WeeklyResultByStoreReportViewComponent } from './pages/common/reports/weekly-result-by-store-report/weekly-result-by-store-report-view/weekly-result-by-store-report-view.component';
import { YtdResultByStoreComponent } from './pages/common/reports/ytd-result-by-store/ytd-result-by-store.component';
import { WeeklyResultByBranchComponent } from './pages/common/reports/weekly-result-by-branch/weekly-result-by-branch.component';
import { YtdResultByBranchComponent } from './pages/common/reports/ytd-result-by-branch/ytd-result-by-branch.component';
import { YtdResultByBranchViewComponent } from './pages/common/reports/ytd-result-by-branch/ytd-result-by-branch-view/ytd-result-by-branch-view.component';
import { YtdResultByStoreViewComponent } from './pages/common/reports/ytd-result-by-store/ytd-result-by-store-view/ytd-result-by-store-view.component';
import { WeeklyResultByBranchViewComponent } from './pages/common/reports/weekly-result-by-branch/weekly-result-by-branch-view/weekly-result-by-branch-view.component';
import { WeeklyReportComponent } from './pages/common/reports/weekly-report/weekly-report.component';
import { TerminalComponent } from './pages/common/system/terminal/terminal.component';
import { KitchenComponent } from './pages/common/system/kitchen/kitchen.component';
import { kitchenEditComponent } from './pages/common/system/kitchen/kitchen-edit/kitchen-edit.component';

import { OrderComponent } from './pages/common/reports/order/order.component';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule } from '@angular/material-moment-adapter';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { EmailDialogComponent } from './pages/common/reports/order/dialogs/email-dialog/email-dialog.component';
import { OrderSummaryComponent } from './pages/common/reports/order/order-summary/order-summary.component';
import { TerminalEditComponent } from './pages/common/system/terminal/terminal-edit/terminal-edit.component';
import { DailySalesComponent } from './pages/shop/reports/daily-sales/daily-sales.component';
import { WeeklySalesComponent } from './pages/shop/reports/weekly-sales/weekly-sales.component';
import { AccessLogComponent } from './pages/shop/reports/access-log/access-log.component';
import { HourlySalesReportComponent } from './pages/shop/reports/hourly-sales-report/hourly-sales-report.component';
import { MasterSalesReportCostComponent } from './pages/shop/reports/master-sales-report-cost/master-sales-report-cost.component';
import { DailySalesReportComponent } from './pages/common/reports/daily-sales-report/daily-sales-report.component';
import { ExpenseDetailsReportComponent } from './pages/shop/reports/expense-details-report/expense-details-report.component';
import { DayEndReportComponent } from './pages/shop/reports/day-end-report/day-end-report.component';
import { AccessLogViewDialogComponent } from './pages/shop/reports/access-log/access-log-view-dialog/access-log-view-dialog.component';
import { WeeklyCashAndBankingReportComponent } from './pages/shop/reports/weekly-cash-and-banking-report/weekly-cash-and-banking-report.component';
import { CashVarianceExceptionReportComponent } from './pages/common/reports/cash-variance-exception-report/cash-variance-exception-report.component';
import { AttendanceExceptionReportComponent } from './pages/common/reports/attendance-exception-report/attendance-exception-report.component';
import { HqDailySalesComponent } from './pages/common/reports/daily-sales/daily-sales.component';
import { HqWeeklySalesComponent } from './pages/common/reports/weekly-sales/weekly-sales.component';
import { ExpenseTypeSummaryReportComponent } from './pages/common/reports/expense-type-summary-report/expense-type-summary-report.component';
import { ExpenseComponent } from './pages/common/system/expense/expense.component';
import { ExpenseEditComponent } from './pages/common/system/expense/expense-edit/expense-edit.component';
import { ExpenseTypeComponent } from './pages/common/system/expense-type/expense-type.component';
import { ExpenseTypeEditComponent } from './pages/common/system/expense-type/expense-edit/expense-type-edit.component';
import { UserGroupEditComponent } from './pages/common/users/usergroup/usergroup-edit/usergroup-edit.component';

import { MenuComponent } from './pages/common/products/menu/menu.component';
import { MenuEditComponent } from './pages/common/products/menu/menu-edit/menu-edit.component';
import { YearlyResultByWeekReportShopComponent } from './pages/shop/reports/yearly-result-by-week-report-shop/yearly-result-by-week-report-shop.component';
import { MasterSalesReportComponent } from './pages/common/reports/master-sales-report/master-sales-report.component';
import { YearlyResultByWeekReportComponent } from './pages/common/reports/yearly-result-by-week-report/yearly-result-by-week-report.component';
import { ReasonsComponent } from './pages/common/system/reasons/reasons.component';
import { ReasonsEditComponent } from './pages/common/system/reasons/reasons-edit/reasons-edit.component'
import { SalesReportByGroupComponent } from './pages/shop/reports/sales-report-by-group/sales-report-by-group.component';
import { AutoDiscountComponent } from './pages/common/promotions/auto-discount/auto-discount.component';
import { AutoDiscountEditComponent } from './pages/common/promotions/auto-discount/auto-discount-edit/auto-discount-edit.component';
import { ComboEditComponent } from './pages/common/products/combo/combo-edit/combo-edit.component';
import { ComboComponent } from './pages/common/products/combo/combo.component';
import { CustomizationEditComponent } from './pages/common/products/customization/customization-edit/customization-edit.component';
import { CustomizationComponent } from './pages/common/products/customization/customization.component';
import { ProductDialogComponent } from './pages/common/promotions/auto-discount/dialogs/product-dialog/product-dialog.component';
import { ProductItemDialogComponent } from './pages/common/promotions/auto-discount/dialogs/product-item-dialog/product-item-dialog.component';
import { ItemClassDisplayOrderComponent } from './pages/common/products/item-class-display-order/item-class-display-order.component';
import { SaleItemDisplayOrderComponent } from './pages/common/products/sale-item-display-order/sale-item-display-order.component';
import { HotItemDisplayOrderComponent } from './pages/common/products/hot-item-display-order/hot-item-display-order.component';
import { ItemDiscountDisplayOrderComponent } from './pages/common/promotions/item-discount-display-order/item-discount-display-order.component';
import { UnderConstructionComponent } from './pages/common/under-construction/under-construction.component';
import { DiscountComponent } from './pages/common/promotions/discount/discount.component';
import { DiscountEditComponent } from './pages/common/promotions/discount/discount-edit/discount-edit.component';
import { SaleItemDiscountDialogComponent } from './pages/common/promotions/discount/discount-edit/sale-item-discount-dialog/sale-item-discount-dialog.component';
import { SaleItemDeleteConformationDialogComponent } from './pages/common/promotions/discount/discount-edit/sale-item-delete-conformation-dialog/sale-item-delete-conformation-dialog.component';
import { EmployeeEditComponent } from './pages/common/employees/employee/employee-edit/employee-edit.component';
import { UserEditComponent } from './pages/common/users/user/user-edit/user-edit.component';
import { TerminalSyncLogComponent } from './pages/common/utils/terminal-sync-log/terminal-sync-log.component';
import { VoucherComponent } from './pages/common/promotions/voucher/voucher.component';
import { VoucherEditComponent } from './pages/common/promotions/voucher/voucher-edit/voucher-edit.component';
import { CustomMenuComponent } from './pages/common/users/custom-menu/custom-menu.component';
import { GroupItemListPopupComponent } from './pages/common/products/sale-item/group-item-list-popup/group-item-list-popup.component';
import { GroupItemEditPopupComponent } from './pages/common/products/sale-item/group-item-edit-popup/group-item-edit-popup.component';
import { UsergroupPermissionsComponent } from './pages/common/users/usergroup/usergroup-permissions/usergroup-permissions.component';
import { DataPermissionDialogComponent } from './pages/common/users/usergroup/usergroup-permissions/data-permission-dialog/data-permission-dialog.component';
import { StaffAttendanceComponent } from './pages/shop/people/staff-attendance/staff-attendance.component';
import { EmployeeBrowseDialogComponent } from './pages/shop/people/staff-attendance/employee-browse-dialog/employee-browse-dialog.component';
import { ShopPricePopupComponent } from './pages/common/products/sale-item/shop-price-popup/shop-price-popup.component';


import { CustomMenuItemComponent } from './pages/common/users/custom-menu-item/custom-menu-item.component';
import { AreaManagerShopComponent } from './pages/common/users/area-manager-shop/area-manager-shop.component';
import { VersionUpdaterComponent } from './pages/common/utils/version-updater/version-updater.component';
import { VersionUpdatedShopListComponent } from './pages/common/utils/version-updater/version-updated-shop-list/version-updated-shop-list.component';
import { DashboardComponent } from './pages/common/dashboard/dashboard.component';
import { TodayComponent } from './pages/common/dashboard/dashboard/components/today/today.component';
import { WeekToDateComponent } from './pages/common/dashboard/dashboard/components/week-to-date/week-to-date.component';
import { YtdWeeklyAverageComponent } from './pages/common/dashboard/dashboard/components/ytd-weekly-average/ytd-weekly-average.component';
import { YearToDateComponent } from './pages/common/dashboard/dashboard/components/year-to-date/year-to-date.component';
import { Top20TodayComponent } from './pages/common/dashboard/dashboard/components/top-20-today/top-20-today.component';
import { Top20ThisWeekComponent } from './pages/common/dashboard/dashboard/components/top-20-this-week/top-20-this-week.component';
import { RegionalSalesComponent } from './pages/common/dashboard/dashboard/components/regional-sales/regional-sales.component';
import { StaffAttendanceEditComponent } from './pages/shop/people/staff-attendance/staff-attendance-edit/staff-attendance-edit.component';
import { ResultsByStoreComponent } from './pages/common/dashboard/dashboard/components/results-by-store/results-by-store.component';
import { StoreSelectionDialogComponent } from './pages/common/dashboard/dashboard/dialogs/store-selection-dialog.component';
import { ItemClassComponent } from './pages/common/products/item-class/item-class.component';
import { ItemClassEditComponent } from './pages/common/products/item-class/item-class-edit/item-class-edit.component';
import { AccessDeniedComponent } from './pages/common/access-denied/access-denied.component';
import { DtDashboardComponent } from './pages/common/dashboard/dt-dashboard/dt-dashboard.component';
import { TodayDtComponent } from './pages/common/dashboard/dt-dashboard/components/today/today-dt.component';
import { WeekToDateDtComponent } from './pages/common/dashboard/dt-dashboard/components/week-to-date/week-to-date-dt.component';
import { YtdWeeklyAverageDtComponent } from './pages/common/dashboard/dt-dashboard/components/ytd-weekly-average/ytd-weekly-average-dt.component';
import { YearToDateDtComponent } from './pages/common/dashboard/dt-dashboard/components/year-to-date/year-to-date-dt.component';
import { DayPartSalesByDepartmentComponent } from './pages/common/dashboard/dt-dashboard/components/day-part-sales-by-department/day-part-sales-by-department.component';
import { DtShopSalesByDepartmentComponent } from './pages/common/dashboard/dt-dashboard/components/dt-shop-sales-by-department/dt-shop-sales-by-department.component';
import { StoreSelectionDialogDtComponent } from './pages/common/dashboard/dt-dashboard/dialogs/store-selection-dialog-dt.component';
import { HqDashboardComponent } from './pages/common/dashboard/dashboard/dashboard.component';
import { PayrollMenuComponent } from './pages/common/payroll/payroll-menu/payroll-menu.component';


import { SubMenuLayoutComponent } from './common/layouts/sub-menu-layout/sub-menu-layout.component';
import { StaffPayrollGroupEditComponent } from './pages/common/payroll/staff-payroll-group/staff-payroll-group-edit/staff-payroll-group-edit.component';
import { AttendanceExportComponent } from './pages/common/payroll/attendance-export/attendance-export.component';
import { AttendanceDataExportComponent } from './pages/common/payroll/attendance-export/components/attendance-data-export/attendance-data-export.component';
import { AttendanceHourLimitComponent } from './pages/common/payroll/attendance-export/components/attendance-hour-limit/attendance-hour-limit.component';
import { AttendanceInoutComponent } from './pages/common/payroll/attendance-export/components/attendance-inout/attendance-inout.component';
import { EditEmployeePayrollCodeComponent } from './pages/common/payroll/attendance-export/components/validate-payroll-code/edit-employee-payroll-code/edit-employee-payroll-code.component';
import { AttendanceValidatePayrollCodeComponent } from './pages/common/payroll/attendance-export/components/validate-payroll-code/validate-payroll-code.component';
import { PayrollGroupEditComponent } from './pages/common/payroll/payroll-group/payroll-group-edit/payroll-group-edit.component';
import { PayrollGroupComponent } from './pages/common/payroll/payroll-group/payroll-group.component';
import { ShopPayrollSettingsEditComponent } from './pages/common/payroll/shop-payroll-settings/shop-payroll-settings-edit/shop-payroll-settings-edit.component';
import { ShopPayrollSettingsComponent } from './pages/common/payroll/shop-payroll-settings/shop-payroll-settings.component';
import { StaffPayrollGroupComponent } from './pages/common/payroll/staff-payroll-group/staff-payroll-group.component';
import { UserGroupComponent } from './pages/common/users/usergroup/usergroup.component';
import { AdsSettingsEditComponent } from './pages/common/utils/ads-settings/components/ads-settings-edit/ads-settings-edit.component';
import { SyncErrorComponent } from './pages/common/utils/sync-error/sync-error.component';
import { AdsShopSelectionComponent } from './pages/common/utils/ads-settings/components/ads-shop-selection/ads-shop-selection.component';
import { AdsFileUploadComponent } from './pages/common/utils/ads-settings/components/ads-file-upload/ads-file-upload.component';
import { AdsSettingsComponent } from './pages/common/utils/ads-settings/ads-settings.component';
import { EmployeeJobPositionComponent } from './pages/common/employees/employee-job-position/employee-job-position/employee-job-position.component';
import { EmployeeJobPositionEditComponent } from './pages/common/employees/employee-job-position/employee-job-position-edit/employee-job-position-edit.component';
import { EmployeeJobTitleComponent } from './pages/common/employees/employee-job-title/employee-job-title/employee-job-title.component';
import { EmployeeJobTitleEditComponent } from './pages/common/employees/employee-job-title/employee-job-title-edit/employee-job-title-edit.component';
import { EmployeeStatusComponent } from './pages/common/employees/employee-status/employee-status/employee-status.component';
import { EmployeeStatusEditComponent } from './pages/common/employees/employee-status/employee-status-edit/employee-status-edit.component';
import { CodeDirective } from './common/directives/code.directive';
// import { StaffPayrollGroupEditComponent } from './pages/common/employees/staff-payroll-group/staff-payroll-group-edit/staff-payroll-group-edit.component';
// Custom Date Format
// Custom Date Format
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY',
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'DD-MM-YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@NgModule({
  declarations: [
    AppComponent,
    ToolbarComponent,
    SidenavComponent,
    LoginComponent,
    UserInfoComponent,
    ConfirmDialogComponent,
    MasterFloatingMenuComponent,
    // UserComponent,
    // UserListItemComponent,
    SnackBarComponent,
    // UserEditDialogComponent,
    StylePaginatorDirective,
    SimplePaginatorComponent,
    SorterComponent,
    SearchFilterComponent,
    FilterItemComponent,
    LoaderComponent,
    // UserEditComponent,
    SearchFilterComponent,
    // UserSummaryComponent,
    ExtraPagesMenuComponent,
    // ChangePasswordDialogComponent,
    SearchFilterLoadDialogComponent,
    SearchFilterSaveDialogComponent,
    SearchFilterSaveDialogComponent,
    FilterDialogComponent,
    OrderStatusPipe,
    ReversePipe,
    DaysCustomPipe,
    MonthsCustomPipe,
    OODatePipe,
    ExtraPagesMenuComponent,
    EmployeeMenuComponent,
    EmployeeComponent,
    EmployeeExtComponent,
    EmployeeExtEditComponent,
    SystemComponent,
    SystemMenuComponent,
    ProductComponent,
    ProductMenuComponent,
    PromotionMenuComponent,
    PromotionComponent,
    ReportComponent,
    UserMenuComponent,
    UserComponent,
    UtilMenuComponent,
    // UtilComponent,
    ReportMenuComponent,
    AreaComponent,
    AreaSummaryComponent,
    AreaEditComponent,
    DepartmentComponent,
    DepartmentEditComponent,
    DepartmentSummaryComponent,
    ExpenseComponent,
    ExpenseEditComponent,
    ExpenseTypeComponent,
    ExpenseTypeEditComponent,
    ReasonsComponent,
    ReasonsEditComponent,
    EmployeeCategoryComponent,
    EmployeeCategorySummaryComponent,
    EmployeeCategoryEditComponent,
    ShopinfoComponent,
    ShopSummaryComponent,
    ShopEditComponent,
    SystemSettingsComponent,
    UomComponent,
    UomEditComponent,
    UomSummaryComponent,
    ItemCategoryComponent,
    ItemCategoryEditComponent,
    ItemCategorySummaryComponent,
    StockCategoryComponent,
    StocksSummaryComponent,
    StockCategoryEditComponent,
    StocksComponent,
    StocksSummaryComponent,
    StocksEditComponent,
    SaleItemComponent,
    SaleItemEditComponent,
    SaleItemSummaryComponent,
    SaleItemBulkUpdateComponent,
    SaleItemBulkUpdateExportDialogComponent,
    SaleItemBulkUpdateScheduleDialogComponent,
    SaleItemBulkUpdateImportDialogComponent,
    WeeklyResultByStoreReportComponent,
    WeeklyResultByStoreReportViewComponent,
    YtdResultByStoreComponent,
    WeeklyResultByBranchComponent,
    YtdResultByBranchComponent,
    YtdResultByBranchViewComponent,
    YtdResultByStoreViewComponent,
    WeeklyResultByBranchViewComponent,
    CashVarianceExceptionReportComponent,
    AttendanceExceptionReportComponent,
    WeeklyReportComponent,
    TerminalComponent,
    KitchenComponent,
    kitchenEditComponent,
    OrderComponent,
    EmailDialogComponent,
    OrderSummaryComponent,
    TerminalEditComponent,
    DailySalesComponent,
    WeeklySalesComponent,
    AccessLogComponent,
    TerminalEditComponent,
    HourlySalesReportComponent,
    DailySalesReportComponent,
    DayEndReportComponent,
    ExpenseDetailsReportComponent,
    MasterSalesReportCostComponent,
    AccessLogViewDialogComponent,
    WeeklyCashAndBankingReportComponent,
    HqDailySalesComponent,
    HqWeeklySalesComponent,
    ExpenseTypeSummaryReportComponent,
    UserGroupComponent,
    UserGroupEditComponent,
    MenuComponent,
    MenuEditComponent,
    YearlyResultByWeekReportComponent,
    YearlyResultByWeekReportShopComponent,
    MasterSalesReportComponent,
    AutoDiscountComponent,
    AutoDiscountEditComponent,
    ProductDialogComponent,
    ProductItemDialogComponent,
    CustomizationComponent,
    CustomizationEditComponent,
    ComboComponent,
    ComboEditComponent,
    SalesReportByGroupComponent,
    ItemClassDisplayOrderComponent,
    SaleItemDisplayOrderComponent,
    HotItemDisplayOrderComponent,
    ItemDiscountDisplayOrderComponent,
    UnderConstructionComponent,
    DiscountComponent,
    DiscountEditComponent,
    SaleItemDiscountDialogComponent,
    SaleItemDeleteConformationDialogComponent,
    TerminalSyncLogComponent,
    EmployeeEditComponent,
    UserEditComponent,
    VoucherComponent,
    VoucherEditComponent,
    CustomMenuComponent,
    GroupItemListPopupComponent,
    GroupItemEditPopupComponent,
    UsergroupPermissionsComponent,
    DataPermissionDialogComponent,
    StaffAttendanceComponent,
    EmployeeBrowseDialogComponent,
    ShopPricePopupComponent,
    StaffAttendanceEditComponent,
    CustomMenuItemComponent,
    AreaManagerShopComponent,
    PayrollGroupComponent,
    PayrollGroupEditComponent,
    ShopPayrollSettingsComponent,
    ShopPayrollSettingsEditComponent,
    StaffPayrollGroupComponent,

    AttendanceExportComponent,
    AttendanceValidatePayrollCodeComponent,
    AttendanceInoutComponent,
    AttendanceHourLimitComponent,
    AttendanceDataExportComponent,

    VersionUpdaterComponent,
    VersionUpdatedShopListComponent,
    DashboardComponent,
    AttendanceDataExportComponent,
    EditEmployeePayrollCodeComponent,

    HqDashboardComponent,
    TodayComponent,
    WeekToDateComponent,
    YtdWeeklyAverageComponent,
    YearToDateComponent,
    Top20TodayComponent,
    Top20ThisWeekComponent,
    RegionalSalesComponent,
    ResultsByStoreComponent,
    StoreSelectionDialogComponent,
    ItemClassComponent,
    ItemClassEditComponent,
    AccessDeniedComponent,

    DtDashboardComponent,
    TodayDtComponent,
    WeekToDateDtComponent,
    YtdWeeklyAverageDtComponent,
    YearToDateDtComponent,
    DayPartSalesByDepartmentComponent,
    DtShopSalesByDepartmentComponent,
    StoreSelectionDialogDtComponent,
    PayrollMenuComponent,

    SubMenuLayoutComponent,


    StaffPayrollGroupEditComponent,
    SyncErrorComponent,

    AdsSettingsEditComponent,
    AdsShopSelectionComponent,
    AdsFileUploadComponent,
    AdsSettingsComponent,
    CodeDirective,
    EmployeeJobPositionComponent,
    EmployeeJobPositionEditComponent,
    EmployeeJobTitleComponent,
    EmployeeJobTitleEditComponent,
    EmployeeStatusComponent,
    EmployeeStatusEditComponent,



  ],
  bootstrap: [AppComponent], imports: [
    BrowserModule,
    AppRoutingModule,
    CommonModule,
    MatAutocompleteModule,
    BrowserAnimationsModule,
    NgxChartsModule,
    ReactiveFormsModule,
    MaterialModule,
    FormsModule,
    MatFormFieldModule,
    MatMomentDateModule, // Moment adapter for MatDatepicker
    MatInputModule,
    CdkDropList,
    CdkDrag,
    DragDropModule,
    QuillModule.forRoot({
      modules: {
        resize: {
          showSize: false,
          toolbar: {
            sizeTools: false,
            alingTools: true
          },
        },
      },
      theme: 'snow'
    }),

  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: MY_DATE_FORMATS
    },
    {
      provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS,
      useValue: { useUtc: true } // optional, if you want UTC handling
    },
    provideHttpClient(withInterceptorsFromDi()),
    DatePipe,
    provideAnimationsAsync()
  ]
})
export class AppModule { }